// 对http请求进行封装
import axios from 'axios'
// import {logout} from "./personal-api"
import {showErrorMsg, showWaringMsg} from "../utils/msg";
// import {COMMIT_SET_USER_INFO} from "@constants/mutation-type/login-mutation-type";
// 使用自定义的配置文件发送请求
const instance = axios.create({
    baseURL: '',
    timeout: 10000,
    // timeout: 10,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
    }
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    //排除个人信息接口
    //如果多人登录，强制下线
    // if (response.config.url != "/api/pcUser/login-user/info" && response.data.code == 403) {
    //     console.log("拦截器：")
    //     console.log(response)
    //     // this.$message.warning("您的账号在别处登录，如非本人操作，请立即更改密码！")
    //     // eslint-disable-next-line no-undef
    //     showWaringMsg("请重新登录！")
    //     // 修改vuex状态
    //     this.$store.commit(COMMIT_SET_USER_INFO, {
    //         isLogin: false,
    //     });
    // }
    // if (response.config.url == 'http://wk.myhope365.com/login') {
    //     showWaringMsg("请重新登录！")
    //     // 修改vuex状态
    //     this.$store.commit(COMMIT_SET_USER_INFO, {
    //         isLogin: false,
    //     });
    //     this.$router.push("/index")
    // }

    if (response.status === 200) {
       if(response.data.code===0){
           return response.data;
       }else if (response.data.code===500){
           if(response.data.msg !== '当前未登录'){
               showErrorMsg(response.data.msg)
           }
       }
    } else {
        console.error("请求错误")
        console.error(response)
    }
    return response;
}, function (error) {
    console.log(error)
    // todo 暂时对报错信息进行处理，后续更新了小程序之后再更新这里的逻辑
    if (!error.code && !error.response) {
        // 退出登录
        showWaringMsg("登录失效，请重新登录！");
        // 修改vuex状态
        // setTimeout(() => {
        //     window.location.href = '/';
        // }, 1500);
    }
    return Promise.reject(error);
});


// 做了一个发送http请求的工具，通过这个工具发送的请求会带上我们的配置
export default instance;
